import { Component } from '@angular/core';

import { ActionSheet, ActionSheetController, Config, NavController, ToastController } from 'ionic-angular';

import { NotificationData } from '../../providers/notification-data';
import { UECreatePage } from '../ue/ue-create';
import { KontrollenCreatePage } from '../kontrollen/kontrollen-create';
import { NotificationDetailPage } from '../notifications/notification-detail';
import { UserData } from '../../providers/user-data';
import { Http, Headers, RequestOptions } from '@angular/http';
import { CommonData } from '../../providers/common-data';
import { Geolocation } from '@ionic-native/geolocation';
import { Platform } from 'ionic-angular';

@Component({
  selector: 'notification-list',
  templateUrl: 'notification-list.html'
})
export class NotificationListPage {
  actionSheet: ActionSheet;


  constructor(  
               public common: CommonData
             , public actionSheetCtrl: ActionSheetController
             , public navCtrl: NavController
             ,  public http: Http
             , public notificationData: NotificationData
             , public config: Config
             , public userData: UserData


             ) {

             
    //this.notifications = notificationData.data;
    //this.reorderNotifications();
  }

  doRefresh(refresh){
        //this.notificationData.viewmode = this.viewmode;
        Promise.all([
            this.notificationData.load(),            
          ]).then(data => {
            //console.log(data);
            refresh.complete();     
          });    
    
  }  
  ionViewWillEnter(){

    if(this.notificationData.newmessages.length == 1){
        this.navCtrl.push(NotificationDetailPage, this.notificationData.newmessages[0],{animate: true, animation: 'ios-transition'});
    }
  }
  
  showDetail(notification) {
    //console.log(notification);
    if(!this.common.wifierror){
      this.navCtrl.push(NotificationDetailPage, notification,{animate: true, animation: 'ios-transition'});
    }
    else{
      this.common.showWifiError(); 
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/notifications/notification-list.ts